import Sso from './component';
import { SsoProps } from './types';

export default Sso;
export type { SsoProps };
